import * as ACTIONS from "./actionTypes";
import { getPersistData } from "../../utils/utils";

const persistData = getPersistData();

export interface TransactionData {
    fileUrl: string;
    message: string;
    warrantyId: number;
    proceedToPayment?: boolean;
    canGenerateReport?: boolean;
}

interface InitialState {
    isTransactionFailed: boolean;
    redirectUrl: string;
    isDownloading: boolean;
    isTransactionInitiating: boolean;
    transactionData?: any;
    cartId?: string;
    isAlreadyPaymentInitiated: boolean;
}

export const initialState: InitialState = {
    transactionData: null,
    cartId: null,
    isTransactionInitiating: false,
    redirectUrl: null,
    isDownloading: false,
    isTransactionFailed: false,
    isAlreadyPaymentInitiated: persistData && persistData.isAlreadyPaymentInitiated,
};

const reducer = (state = initialState, { type, payload }): InitialState => {
    switch (type) {
        case ACTIONS.UPDATE_NAVIGATION_FOR_MULTIPLE_WARRANTIES: {
            return { ...state, redirectUrl: payload.redirectUrl, transactionData: payload };
        }
        case ACTIONS.UPDATE_INIT_TRANSACTION_FOR_MULTIPLE_WARRANTIES: {
            return { ...state, isTransactionInitiating: true };
        }
        case ACTIONS.UPDATE_INIT_TRANSACTION_COMPLETED_FOR_MULTIPLE_WARRANTIES: {
            return { ...state, isTransactionInitiating: false };
        }
        case ACTIONS.UPDATE_TRANSACTION_DATA_FOR_MULTIPLE_WARRANTIES: {
            return { ...state, transactionData: payload.warranties, cartId: payload.shoppingCartId };
        }
        case ACTIONS.CLEAR_TRANSACTION_DATA_FOR_MULTIPLE_WARRANTIES: {
            return { ...state, transactionData: null };
        }
        case ACTIONS.TRANSACTION_FAILED_FOR_MULTIPLE_WARRANTIES: {
            return { ...state, isTransactionFailed: true };
        }
        case ACTIONS.UPDATE_ALREADY_PAYMENT_INITIATED_FOR_MULTIPLE_WARRANTIES: {
            return { ...state, isAlreadyPaymentInitiated: false };
        }
        case ACTIONS.GENERATE_FULL_WARRANTY_FOR_MULTIPLE_WARRANTIES: 
        case ACTIONS.GENERATE_SUMMARY_WARRANTY_FOR_MULTIPLE_WARRANTIES: {
            return { ...state, isDownloading: true };
        }
        case ACTIONS.GENERATE_FULL_WARRANTY_DOWNLOADED_FOR_MULTIPLE_WARRANTIES:
        case ACTIONS.GENERATE_SUMMARY_WARRANTY_DOWNLOADED_FOR_MULTIPLE_WARRANTIES: {
            return { ...state, isDownloading: false };
        }
        case ACTIONS.DOWNLOAD_ALL_WARRANTIES: {
            return { ...state, isDownloading: true };
        }
        case ACTIONS.DOWNLOAD_ALL_WARRANTIES_SUCCESS:
        case ACTIONS.DOWNLOAD_ALL_WARRANTIES_FAILURE: {
            return { ...state, isDownloading: false };
        }
        default: {
            return state;
        }
    }
};

export default reducer;
